import React, { useState } from "react";
import "./customTitleSelect.css"; 
import { FaCaretUp, FaCaretDown } from "react-icons/fa";

interface Props {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  className?: string;   // tighten type
}

const CustomSelect: React.FC<Props> = ({
  options,
  value,
  onChange,
  placeholder = "Select...",
  label,
  className = "",
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={`custom-title-select ${className}`}>
      <div
        className={`selector ${className}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        {value || label || placeholder}
        <span className="arrow">{open ? <FaCaretUp /> : <FaCaretDown />}</span>
      </div>

      {open && (
        <ul className={`dropdown ${className}`}>
          {options.map((opt) => (
            <li
              key={opt}
              className={opt === value ? "active" : ""}
              onClick={() => {
                onChange(opt);
                setOpen(false);
              }}
            >
              {opt}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomSelect;
